export default {
    AUTHOR_FR: '/blogue/author',
    AUTHOR: '/blog/author',
    AUTHORS_FR: '/blogue/authors',
    AUTHORS: '/blog/authors',
    BLOG_FR: '/blogue',
    BLOG: '/blog',
    CATEGORY_FR: '/blogue/category',
    CATEGORY: '/blog/category',
    TAG_FR: '/blogue/tag',
    TAG: '/blog/tag',
    WIZARD_MTG_QUOTER_FR: '/hypotheque/quotes',
    WIZARD_MTG_QUOTER_EN: '/mortgages/quotes',
    AGENT_LIST_FR: '/courtier-hypothecaire-canada',
    AGENT_LIST: '/mortgage-brokers-canada',
    AGENT_DETAILS: '/mortgage-agent-at-ratehub',
    AGENT_DETAILS_FR: '/courtier-hypothecaire-a-ratehub',
    REFERRALS_LANDING_PAGE_EN: '/referral-program', // No FR equivalent yet.

    // ----------------------
    // Hero Tab Content Links
    // ----------------------

    // Mortgages
    BEST_MORTGAGE_RATES_EN: '/best-mortgage-rates',
    BEST_MORTGAGE_RATES_FR: undefined,
    BUYING_MORTGAGE_EN: '/mortgages/quotes/scenario-chooser/new-mortgage',
    BUYING_MORTGAGE_FR: undefined,
    RENEWING_MORTGAGE_EN: '/mortgages/quotes/scenario-chooser/existing-mortgage',
    RENEWING_MORTGAGE_FR: undefined,

    // Insurance
    INS_AUTO_LANDING_PAGE_EN: '/insurance/best-car-insurance-quote',
    INS_AUTO_LANDING_PAGE_FR: '/assurance/assurance-auto',
    INS_HOME_LANDING_PAGE_EN: '/insurance/best-home-insurance-quote',
    INS_HOME_LANDING_PAGE_FR: '/assurance/assurance-habitation',
    INS_LIFE_LANDING_PAGE_EN: '/insurance/life',
    INS_LIFE_LANDING_PAGE_FR: '/assurance/assurance-vie',
    INS_LIFE_QUOTER_EN: '/insurance/life-quotes',
    INS_LIFE_QUOTER_FR: '/assurance/soumission-de-la-vie',

    // Credit Cards
    BEST_TRAVEL_CARDS_EN: '/blog/best-travel-credit-cards-in-canada',
    BEST_TRAVEL_CARDS_FR: undefined,
    BALANCE_TRANSFER_CARDS_EN: '/blog/best-balance-transfer-credit-cards-in-canada-2',
    BALANCE_TRANSFER_CARDS_FR: undefined,
    BEST_OVERALL_CARDS_EN: '/blog/best-credit-cards-in-canada/',
    BEST_OVERALL_CARDS_FR: undefined,
    TOP_PROMOTIONS_CARDS_EN: '/blog/canadas-best-credit-card-promotions-and-sign-up-bonus-offers/',
    TOP_PROMOTIONS_CARDS_FR: undefined,
    FIND_PERFECT_CARD_EN: '/credit-cards/cardfinder/card-type',
    FIND_PERFECT_CARD_FR: undefined,

    // Loans
    BEST_PERSONAL_LOANS_EN: '/loans/best-personal-loans',
    BEST_PERSONAL_LOANS_FR: undefined,
    BEST_CAR_LOANS_EN: '/loans/best-car-loans',
    BEST_CAR_LOANS_FR: undefined,
    DEBT_CONSOLIDATION_CALCULATOR_EN: '/loans/debt-consolidation-calculator',
    DEBT_CONSOLIDATION_CALCULATOR_FR: undefined,
    LOAN_FINDER_EN: '/loans/loanfinder',
    LOAN_FINDER_FR: undefined,

    // Banking
    PERSONAL_CHEQUING_EN: '/chequing-accounts/accounts/personal',
    PERSONAL_CHEQUING_FR: undefined,
    BUSINESS_CHEQUING_EN: '/chequing-accounts/best-business-chequing-account',
    BUSINESS_CHEQUING_FR: undefined,
    HIGH_INTEREST_SAVINGS_EN: '/savings-accounts/accounts/high-interest',
    HIGH_INTEREST_SAVINGS_FR: undefined,

    // Investing
    ROBO_ADVISORS_EN: '/investing/robo-advisors',
    ROBO_ADVISORS_FR: undefined,
    ONLINE_BROKERS_EN: '/investing/best-online-brokerage-canada',
    ONLINE_BROKERS_FR: undefined,
    CRYPTO_EXCHANGES_EN: '/investing/best-crypto-exchanges',
    CRYPTO_EXCHANGES_FR: undefined,
    BEST_GICS_EN: '/gics/best-gic-rates',
    BEST_GICS_FR: undefined,
};
